// The 12 multitrack comparisons shown on the "Multitrack Examples" tab.
//
// Prompts are sampled from a held-out split of MidiCaps. Assets are staged by
// scripts/stage_demo_assets.sh, which also records the Lakh MIDI Dataset hash
// each comparison came from and verifies it against the prompt text.

const ASSET_BASE = '';

const MODELS = [
  { key: 'midi_llm_bf16', name: 'MIDI-LLM', description: 'BF16 precision', isOurs: true },
  { key: 'midi_llm_fp8',  name: 'MIDI-LLM', description: 'FP8-W8A8 precision', isOurs: true },
  { key: 'text2midi',     name: 'Text2midi', description: '(Bhandari et al. 2025)', isBaseline: true },
];

// id -> [display type, Lakh hash id]
const SOURCES = [
  [1,  'Soothing Pop',           'ff5c55c7997d44e4461b896736be53cc'],
  [2,  'Happy Corporate',        'f991cb3523fc5fb6f5cf868a2cbff6ba'],
  [3,  'Classical Strings',      'f9aaed50e11c7088e28b18f797f894a0'],
  [4,  'Emotional Classical',    'fa6cc2c8e86a0e4b42b68a15eb129a63'],
  [5,  'Lively Pop',             'f34379d0e363270a9a54a2abeb33dc07'],
  [6,  'Playful Pizzicato',      'ffbbe9b801ddafd21eb02f67a073b15c'],
  [7,  'Adventurous Orchestral', 'f493b4ecb2937c169258b1a82014e9f8'],
  [8,  'Unsettled Electronic',   'f8b2717bf5f84e05e946a96ec3ca497d'],
  [9,  'Spacey Electronic',      'f90a9a12e076d0e13c3333b6a9efa701'],
  [10, 'Energetic Rock',         'fd70b99b70e0a7c57ce4b65e57138829'],
  [11, 'Slow Rock',              'f63eac1f9c5ba3e332ef13784a0f45e5'],
  [12, 'Festive Christmas',      'f359ae7c4dc88e272648dd0b0d554939'],
];

export const getAudioPath = (id, modelKey) =>
  `${ASSET_BASE}/audio/comparison_${id}/${modelKey}.mp3`;

export const getNotesPath = (id, modelKey) =>
  `${ASSET_BASE}/audio/comparison_${id}/${modelKey}.json`;

export const getPromptPath = (id) =>
  `${ASSET_BASE}/prompts/comparison_${id}.txt`;

export const LAKH_COMPARISONS = SOURCES.map(([id, type, lmdId]) => ({
  id,
  type,
  lmdId,
  label: `#${String(id).padStart(2, '0')} — ${type}`,
  promptFile: getPromptPath(id),
  models: MODELS.map((model) => ({
    ...model,
    audioUrl: getAudioPath(id, model.key),
    notesUrl: getNotesPath(id, model.key),
  })),
}));

export default LAKH_COMPARISONS;
